import React from "react";
import { NavLink } from "react-router-dom";
import { FaUserMd, FaComments } from "react-icons/fa";
import { HiOutlineSquares2X2 } from "react-icons/hi2";
import { IoHelpCircleOutline } from "react-icons/io5";

const AdminSidebar = ({ isOpen }) => {
  return (
    <div
      className={`sidebar bg-white custom-border-end ${isOpen ? "open" : ""}`}
      style={{ width: "240px" }}
    >
      <div className="d-flex flex-column h-100 py-3">
        <ul className="nav flex-column">
          <li className="nav-item mb-1">
            <NavLink
              to="/vendors"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                  isActive ? "btn-danger text-white" : "text-secondary"
                }`
              }
              style={{ borderRadius: "4px", margin: "0 8px" }}
            >
              <HiOutlineSquares2X2 style={{ fontSize: "18px" }} />
              <span className="form-labels">Vendors</span>
            </NavLink>
          </li>
          {/* <li className="nav-item mb-1">
            <NavLink 
              to="/revenue" 
              className={({ isActive }) => `nav-link d-flex align-items-center gap-2 py-2 px-3 ${isActive ? 'btn-danger  text-white' : 'text-secondary'}`}
              style={{ borderRadius: '4px', margin: '0 8px' }}
            >
              <FaChartLine style={{ fontSize: '18px' }} />
              <span style={{ fontSize: '14px',fontWeight:"bold" }}>Revenue</span>
            </NavLink>
          </li> */}
          <li className="nav-item mb-1">
            <NavLink
              to="/users"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                  isActive ? "btn-danger  text-white" : "text-secondary"
                }`
              }
              style={{ borderRadius: "4px", margin: "0 8px" }}
            >
              <FaUserMd style={{ fontSize: "18px" }} />
              <span className="form-labels">Users</span>
            </NavLink>
          </li>
          {/* <li className="nav-item mb-1">
            <NavLink 
              to="/chat" 
              className={({ isActive }) => `nav-link d-flex align-items-center gap-2 py-2 px-3 ${isActive ? 'btn-danger  text-white' : 'text-secondary'}`}
              style={{ borderRadius: '4px', margin: '0 8px' }}
            >
              <IoHelpCircleOutline style={{ fontSize: '18px' }} />
              <span className='form-labels'>Support</span>
            </NavLink>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default AdminSidebar;
